import { Component, HostBinding, Input } from '@angular/core';
import { MuiIconFont } from '../icon';

@Component({
  selector: 'mui-context-menu-item',
  template: `
    <mui-icon *ngIf="icon" [font]="iconFont" [name]="icon" class="mui-context-menu__item__icon"></mui-icon>
    <span class="mui-context-menu__item__label">
      <ng-content></ng-content>
    </span>
  `
})
export class MuiContextMenuItem {
  @Input()
  icon?: string;

  @Input()
  iconFont = MuiIconFont.FONTAWESOME;

  @Input()
  disabled = false;

  @HostBinding('class.mui-context-menu__item')
  _muiBaseClass = true;

  @HostBinding('attr.role')
  readonly role = 'menuitem';

  @HostBinding('attr.aria-disabled')
  @HostBinding('attr.disabled')
  protected get _disabledAttr(): boolean | null {
    return this.disabled ? true : null;
  }
}
